class Behaviour {

    constructor(behaviour) {
        if (! behaviour in this) {
            throw new Error("Behaviour not defined.");
        }
        this.behaviour = behaviour;
    }

    run(form, response) {
        return this[this.behaviour](form, response);
    }

    sleep(form) {
        form.stopProcessing();
    }

    reload() {
        window.location.reload(true);
    }

    redirect(form, response) {
        window.location.href = response.data.url;
    }

    alert(form, response) {
        form.stopProcessing();
        window.EventHandler.fire('top-alert', {
            id: 'form-alert',
            message: response.data.message
        });
    }

    alertClearInput(form, response) {
        form.stopProcessing();
        window.EventHandler.fire('top-alert', {
            id: 'form-alert',
            message: response.data.message
        });
        form.reset();
    }

    confirm(form, response) {
        form.stopProcessing();
        window.EventHandler.fire('top-confirm', {
            id: 'form-confirm',
            message: response.data.message,
            url: response.data.url
        });
        window.EventHandler.listen('form-confirm-closed', () => {

        });
    }

    ask(form, response) {
        this[response.data.behaviour](form, response);
    }

    fadeOutShowMessage(form, response) {
        form.stopProcessing();
        // todo
    }

}

export default Behaviour;